export interface ShareWishlist {
  subject: string;
  email_subject: string;
  message_phrase: string;
  item_details_phrase: string;
  wishlist_phrase: string;
  email_has_been_sent_phrase: string;
}
